/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useMemo, useState } from 'react';
import { VbzModal } from '@smiles/voebiz-ui-kit';
import ModalBody from 'reactstrap/lib/ModalBody';
import { Col, Container, Row, CustomInput } from 'reactstrap';
import { useTranslation } from 'react-i18next';
import { ModalBeficiariesProps } from './types/type';
import { SyntheticEvent } from '../../../types/event.type';
import { useSelectedMembers, IMember, IPlan } from '../../../contexts/SelectedMembers';

const ModalAddingBeneficiaries = ({
  isBeneficiariesButton,
  closeModalBeneficiaries,
  isAddBenefitButton,
  isEditButtonProfile,
  profile,
  addBeneficiaryHandler,
  isLoading,
  setIsContractedPlanRemoved,
  isAddBenefitProfile
}: ModalBeficiariesProps) => {
  const { t } = useTranslation('modalAddingBeneficiaries');

  const [valueCheckbox, setValueCheckbox] = useState<string[]>([]);
  const [buttonSave, setButtonSave] = useState(true);
  const { selectedMembers } = useSelectedMembers();
  const plans = t('plans', { returnObjects: true }) as Array<string>;

  const backButton = useMemo(() => window.innerWidth > 768, [window.innerWidth]);
  const closedButton = useMemo(() => window.innerWidth <= 768, [window.innerWidth]);

  const handleSelectPlans = async (event: SyntheticEvent) => {
    if (!valueCheckbox.includes(event.target.id)) {
      setValueCheckbox([...valueCheckbox, event.target.id]);
    }

    if (event.target.checked === false) {
      const auxArray = [...valueCheckbox];
      for (let indice = 0; indice < valueCheckbox.length; indice += 1) {
        if (valueCheckbox[indice] === event.target.id) {
          auxArray.splice(indice, 1);
          setValueCheckbox(auxArray);
        }
      }
    }
  };

  const handleAddPlans = async () => {
    setButtonSave(true);
    if (addBeneficiaryHandler) await addBeneficiaryHandler({ values: valueCheckbox });
    setButtonSave(false);
  };

  const handleSavePlans = async () => {
    setButtonSave(true);
    if (addBeneficiaryHandler) await addBeneficiaryHandler({ values: valueCheckbox });
    setButtonSave(false);

    if (setIsContractedPlanRemoved) {
      valueCheckbox.includes(profile?.currentPlan.miles || '')
        ? setIsContractedPlanRemoved(true)
        : setIsContractedPlanRemoved(false);
    }
  };

  const handleCloseModalBeneficiaries = () => {
    closeModalBeneficiaries();
  };

  const loadPlansAvailable = () => {
    const arr: string[] = [];
    profile?.planList.map((plan) => arr.push(plan.miles));
    setValueCheckbox(arr);
  };

  useEffect(() => {
    if (isEditButtonProfile) {
      loadPlansAvailable();
    }
  }, [isEditButtonProfile, profile]);

  useEffect(() => {
    const allPlanList: any[] = [];

    selectedMembers.forEach((member: IMember) => {
      member.planList.forEach((plan: IPlan) => {
        if (!allPlanList.some((item: any) => item === plan.miles)) {
          allPlanList.push(plan.miles);
        }
      });
    });

    setValueCheckbox(allPlanList);
  }, [selectedMembers]);

  useEffect(() => {
    valueCheckbox.length > 0 ? setButtonSave(false) : setButtonSave(true);
  }, [valueCheckbox]);

  const onExit = () => {
    setValueCheckbox([]);
  };

  return (
    <VbzModal
      isOpen={isBeneficiariesButton || isAddBenefitButton || isEditButtonProfile}
      type="right"
      toggle={handleCloseModalBeneficiaries}
      backButton={backButton}
      closedButton={closedButton}
      id="modal-add-beneficiaries"
      className="vbz-modal-add-benefits"
      onExit={onExit}
    >
      <ModalBody>
        <Container>
          <Row className="d-block">
            <Col>
              <h1 style={{ fontSize: '24px', color: '#333333' }}>{t(isEditButtonProfile ? 'title_edit' : 'title')}</h1>
              <div className="text-modal">
                <span style={{ color: '#737373' }}>{isAddBenefitProfile ? t('subtitle') : t(isEditButtonProfile ? 'subtitle_edit' : 'subtitle-add-edit')}</span>
              </div>
            </Col>
            <Col className="d-flex p-4 m-4 flex-column absolute">
              {plans?.map((plan) => (
                <div key={plan}>
                  <CustomInput
                    id={plan}
                    type="checkbox"
                    style={{ width: 0, left: '0' }}
                    onChange={(event) => handleSelectPlans(event)}
                    data-testid={`input-${plan}`}
                    aria-label="cost-input"
                    checked={valueCheckbox.includes(plan)}
                  />
                  <p
                    style={{ position: 'relative', top: '-24px', left: '24px', color: 'black' }}
                  >{`Plano ${new Intl.NumberFormat().format(Number(plan))}`}</p>
                </div>
              ))}
            </Col>
          </Row>
          <div style={{ marginTop: '-20px' }}>
            {isBeneficiariesButton || isEditButtonProfile ? (
              <button
                type="button"
                className="btn-modals"
                disabled={buttonSave || isLoading}
                onClick={handleSavePlans}
                data-testid="btn-add-testid"
              >
                {t('btn_save')}
              </button>
            ) : (
              <button
                type="button"
                className="btn-modals"
                disabled={buttonSave || isLoading}
                data-testid="btn-add-testid"
                onClick={handleAddPlans}
              >
                {t('btn_add')}
              </button>
            )}
          </div>
          <div className="mt-3">
            <span
              style={{ position: 'relative', top: '8px', cursor: 'pointer' }}
              onClick={handleCloseModalBeneficiaries}
            >
              {t('link_back')}
            </span>
            <hr style={{ width: '42px', border: '1px solid #999999', borderRadius: '100px', position: 'absolute' }} />
          </div>
        </Container>
      </ModalBody>
    </VbzModal>
  );
};

export default ModalAddingBeneficiaries;
